import styled from 'styled-components';

export const ProgramNameStyled = styled.h4`
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 16px;
`;

export const StyledTileGrids = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 10px;
  height: 40px;
  font-size: ${({ theme: { fontSizes = {} } = {} }) => fontSizes.title[600]};
  font-weight: ${({ theme: { fontWeights } = {} }) => fontWeights.semibold};
`;

export const StyledTileMarginGrids = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 5px;
  font-size: ${({ theme: { fontSizes = {} } = {} }) => fontSizes.title[600]};
  font-weight: ${({ theme: { fontWeights } = {} }) => fontWeights.semibold};
`;
